import { render, staticRenderFns } from "./FuneralHomeCreditTable.vue?vue&type=template&id=1895d778"
import script from "./FuneralHomeCreditTable.vue?vue&type=script&lang=js"
export * from "./FuneralHomeCreditTable.vue?vue&type=script&lang=js"
import style0 from "./FuneralHomeCreditTable.vue?vue&type=style&index=0&id=1895d778&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports